import { createSlice } from '@reduxjs/toolkit';

import { SlicePayload, UntypedObject } from '@/types';

export type NotebookState = UntypedObject;

export const initialState: NotebookState = {
};

const notebook = createSlice({
  name: 'notebook',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    getUserNotebook: (_state, _action: SlicePayload<{ pickId: string }>) => {
    },

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    getUserNotebookSuccess: (_state, _action: SlicePayload<{ notebook: UntypedObject }>) => {
    },

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    updateUserNotebook: (_state, _action: SlicePayload<{ content: { pickId: string; note: any } }>) => {
    },

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    updateUserNotebookSuccess: (_state, _action: SlicePayload<{ notebook: UntypedObject }>) => {
    }
  }
});

export const {
  getUserNotebook, getUserNotebookSuccess, updateUserNotebook, updateUserNotebookSuccess
} = notebook.actions;

export default notebook.reducer;
